import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "row m-0" }
const _hoisted_3 = { class: "d-flex pt-2 pb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "Cancelar", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Guardar Cambios ")

import Modal from "@/components/Modal.vue";
import { TicketModule } from "@/store/modules/Ticket";
import { ModalSidebarState, Field } from "@/types/components";
import Select, { SelectProps } from "@/components/Inputs/SelectControlled.vue";
import { Form } from "vee-validate";
import { generateDynamicSchema } from "@/store/schemas/client.schema";
import { computed, onMounted, ref } from "vue";
import { flatObject } from "@/util/utils";
import { AuthModule } from "@/store/modules/Auth";
import { AlertModule } from "@/store/modules/Alert";
import { coreApi } from "@/conection";
type FormPayload = {
	[k: string]: any;
};

// state

export default /*#__PURE__*/_defineComponent({
  props: {
    open: { type: Boolean }
  },
  emits: ["changeModal"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", t: ModalSidebarState): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { open: boolean }

const fields: { [k: string]: Field } = {
	"customer.first_name": {
		label: "Primer nombre",
		type: "text",
		placeholder: "Digite el primer nombre del cliente",
		name: "first_name",
		validate: {
			required: "Este campo es obligatorio",
			min: 2,
			max: 25,
		},
	},
	"customer.second_name": {
		label: "Segundo nombre",
		type: "text",
		placeholder: "Digite el segundo nombre del cliente",
		name: "second_name",
		validate: {
			min: 2,
			max: 25,
		},
	},
	"customer.third_name": {
		label: "Tercer nombre",
		type: "text",
		placeholder: "Digite el tercer nombre del cliente",
		name: "third_name",
		validate: {
			min: 2,
			max: 25,
		},
	},
	"customer.last_name": {
		label: "Primer apellido",
		type: "text",
		placeholder: "Digite el primer apellido del cliente",
		name: "last_name",
		validate: {
			required: "Este campo es obligatorio",
			min: 2,
			max: 25,
		},
	},
	"customer.last_name2": {
		label: "Segundo apellido",
		type: "text",
		placeholder: "Digite el segundo apellido del cliente",
		name: "last_name2",
		validate: {
			min: 2,
			max: 25,
		},
	},
	company_name: {
		label: "Empresa / Organización",
		type: "alpha",
		placeholder: "Empresa a la que pertenece el cliente",
		name: "company_name",
		validate: {
			min: 2,
			max: 25,
		},
	},
	email: {
		label: "Correo Electrónico",
		type: "alpha",
		placeholder: "Correo del cliente",
		name: "email",
		validate: {
			email: "Ingrese un correo válido",
		},
	},
	address: {
		label: "Dirección del cliente",
		type: "alpha",
		placeholder: "Dirección física del cliente",
		name: "address",
		validate: {
			min: 5,
			max: 50,
		},
	},
	country: {
		label: "País",
		type: "options",
		placeholder: "Seleccione un país",
		name: "country",
		remote: "https://api.salud.gob.sv/pais",
		query_param: "nombre",
		options: {
			label: "nombre",
			key: "id",
		},
	},
	state: {
		label: "Departamento",
		type: "options",
		placeholder: "Seleccione un departamento",
		name: "state",
		remote: "https://api.salud.gob.sv/departamentos",
		query_param: "nombre",
		depends_on: {
			name: "country",
			query_param: "idPais",
		},
		options: {
			label: "nombre",
			key: "id",
		},
	},
	city: {
		label: "Municipio",
		type: "options",
		placeholder: "Seleccione un municipio",
		name: "city",
		remote: "https://api.salud.gob.sv/municipios",
		query_param: "nombre",
		depends_on: {
			name: "state",
			query_param: "idDepartamento",
		},
		options: {
			label: "nombre",
			key: "id",
		},
	},
	status: {
		label: "Estado",
		type: "options",
		placeholder: "Seleccione un estado",
		name: "status",
		url: `organization/status/${AuthModule.user?.organization._id}`,
		options: {
			label: "subject",
			key: "_id",
		},
	},
};
const form = ref<{ [k: string]: Field }>({});
const loading = ref(false);
const error = ref("");
// types
const state = ref<FormPayload>({});

// props


// emits


function getComponent(type: Field["type"]) {
	switch (type) {
		case "options":
			return Select;
		default:
			return "base-input";
	}
}
const formState = computed(() => state.value);

function getProps(input: Field, updt: { [k: string]: any }) {
	switch (input.type) {
		case "options":
			return {
				value: input.value,
				label: input.label,
				placeholder: input.placeholder,
				name: input.name,
				remote: input.remote,
				fetch: input.url,
				query_param: input.query_param,
				labelClasses: "text-muted h5 font-weight-normal",
				inputGroupClasses: "input-group",
				select: e => {
					state.value = {
						...state.value,
						[input.name]: Array.isArray(e) ? e.join(",") : e,
					};
				},
				selectOptions: {
					noDataText: "Sin coincidencias",
					size: "small",
					valueKey: input.options?.key ?? "",
					labelKey: input.options?.label ?? "",
				},
				params: input.depends_on
					? {
							depends_on: input.depends_on.query_param,
							[input.depends_on.query_param]:
								updt[input.depends_on.name]?.[input.options?.key ?? ""],
					}
					: undefined,
			} as SelectProps;
		default:
			return input;
	}
}
async function onSubmit(e: FormPayload) {
	loading.value = true;
	const {
		first_name,
		second_name,
		third_name,
		last_name,
		last_name2,
		...payload
	} = e;

	const client: any = payload;
	if (payload.city?.idDepartamento !== payload.state?.id) {
		error.value =
			"Error: El municipio no pertenece al departamento seleccionado";
		loading.value = false;
		return;
	} else if (payload.state?.idPais !== payload.country?.id) {
		error.value = "Error: El departamento no pertence a el país seleccionado";
		loading.value = false;
		return;
	}
	client.customer = {
		name: `${first_name.trim()} ${last_name.trim()}`,
		first_name,
		second_name,
		third_name,
		last_name,
		last_name2,
	};
	client.country = client.country?.nombre;
	client.state = client.state?.nombre;
	client.city = client.city?.nombre;
	const response = await coreApi.put<{ success: boolean; message: string }>(
		`/api/client/${TicketModule.currentTicket?.client[0]._id}`,
		{
			ticket: TicketModule.currentRoomID,
			client,
		}
	);
	if (response.data.success)
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: response.data.message,
			type: "success",
		});
	loading.value = false;
}
onMounted(() => {
	if (!TicketModule.currentTicket?.client) return;
	const client: { [k: string]: any } = flatObject(
		TicketModule.currentTicket?.client[0]
	);

	Object.entries(client).forEach(([key, value]) => {
		if (fields[key])
			fields[key] = {
				...fields[key],
				value: value,
			};
	});
	form.value = fields;
});

return (_ctx: any,_cache: any) => {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.open,
    "modal-classes": "modal-secondary",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emits('changeModal', { show: false }))),
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": "bg-gradient-secondary",
    size: "xl"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, "Información de " + _toDisplayString(_unref(TicketModule).currentRoom?.users[0].username), 1)
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "70vh",
        "view-class": "w-100",
        "wrap-class": "w-100"
      }, {
        default: _withCtx(() => [
          (error.value)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                title: error.value,
                type: "error",
                "show-icon": "",
                onClose: _cache[0] || (_cache[0] = () => (error.value = ''))
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(Form), {
            class: "w-100",
            "validation-schema": _unref(generateDynamicSchema)(Object.values(fields)),
            onSubmit: _cache[2] || (_cache[2] = (e) => onSubmit(e))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (input, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-12 col-md-6 col-lg-3",
                      key: index
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(input.type)), _mergeProps(getProps(input, _unref(formState)), {
                        name: input.name,
                        type: input.type,
                        label: input.label,
                        placeholder: input.placeholder,
                        size: "sm",
                        "small-label": ""
                      }), null, 16, ["name", "type", "label", "placeholder"]))
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_base_button, {
                    type: "link",
                    onClick: _cache[1] || (_cache[1] = () => emits('changeModal', { show: false }))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_base_button, {
                    loading: loading.value,
                    type: "primary",
                    "native-type": "submit",
                    class: "ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})